import gql from 'graphql-tag';
export const userFragment = gql `
  fragment userFields on UserEntity {
    id
    dateOfBirth
    name
    idNumber
    firstName
    lastName
    email
    emailVerifiedAt
    agreedToTerms
    isCardDepositEnabled
    isActive
    isTwoFactorEnabled
    isSmsTwoFactorEnabled
    isEmailTwoFactorEnabled
    officialFirstName
    officialLastName
    frStatus
    isCardDepositEnabled
    country
    city
    address
    nationality
    zip
    phone
    status
    referrerCode
    externalReferrerBalance
    internalReferrerCode
    image
    createdAt
    isZendeskUser
    autoConversionEnabled
    amlComment
    riskLevel
  }
`;
//# sourceMappingURL=user.js.map